import { HttpClient } from '../../../httpClient'
import { queryString } from '../../../httpClient/queryString'
import {
  type OpalApi,
  type OpalApiResponseDocument,
  type ValidatedOperationId,
} from '../../../schema'
import { BlockResponse } from '../types'

type ReadBlockBFF = OpalApi<'ExperimentalReadBlockBFFV1', 200>

export const readBlock: ReadBlockBFF = ({
  params,
}: Parameters<ReadBlockBFF>[0] = {}) => {
  if (!params) {
    throw new Error(
      'readBlock must be provided with params.path.workspace_id and params.path.block_id'
    )
  }

  const url = new URL(
    `/asgard-bff/${params.path.workspace_id}/experimental/blocks/${params.path.block_id}`,
    window.location.origin
  )

  return HttpClient()
    .get<BlockResponse>(url.toString())
    .then((res) => res.data)
}

type ReadBlocksOperationId = ValidatedOperationId<'ReadBlocksBFFV1'>
type ReadBlocksRequest = OpalApi<ReadBlocksOperationId, 200>
type ReadBlocksResponse = OpalApiResponseDocument<ReadBlocksOperationId, 200>

/**
 * @note Set `filter: { is_template: true }` to fetch block templates instead of blocks.
 * @note Set `filter: { plan_id: SOME_ID }` to fetch blocks/block templates for the given plan.
 */
export const readBlocks: ReadBlocksRequest = ({
  params,
}: Parameters<ReadBlocksRequest>[0] = {}) => {
  if (!params || !params.path.workspace_id) {
    throw new Error('readBlocks must be provided with params.path.workspace_id')
  }

  const url = new URL(
    `/asgard-bff/${params.path.workspace_id}/blocks`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get<ReadBlocksResponse>(url.toString())
    .then((res) => res.data)
}
